<template>
    <div class="modal modalslect" id="page2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" v-bind:class="{showcomp:isCompView}">
        <div class="modal-dialog modalslect-dialog" role="document">
            <div class="modal-content modalslect-content">
                <div class="modal-space"></div>
                <div class="modal-body times-new-roman">
    
    
    
                    <ul class="detail-name">
                        <li>
                            <span class="flag" v-bind:style="{background:wordData.color}">
                                                         {{wordData.dicshotname}} 
                                                      </span>
                            <span class="name1">{{wordData.word1}}</span>
                            <span class="name2">{{wordData.examples}}</span><br>
                        </li>
                        <li class="size-switch-wrap">
                            <div class="size-switch">
                                <div class="modal-close-wrap">
                                    <button type="btton" class="btn btn-secondary close" data-dismiss="modal" aria-label="Close" @click="closeComp">閉じる
                                            <i class="material-icons">close</i>
                                            </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <ul class="detail-list">
                        <li class="voice-icon">
                            <ul>
                                <li class="icon1" v-show="wordData.vfname_m_url!==''">
                                    <a href="#" @click="soundPlay(wordData.vfname_m_url)">
                                        <img :src="ojiImage" />
                                    </a>
                                </li>
                                <li class="icon2" v-show="wordData.vfname_f_url!==''">
                                    <a href="#" @click="soundPlay(wordData.vfname_f_url)">
                                        <img :src="obaImage" />
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li class="detail-phoneme"><span class="font2">{{wordData.phoneme1}}</span></li>
                        <li class="detail-mean">
                            <div v-if="wordData.categoryname!=''">意味分野：{{wordData.categoryname}}</div>
                            <div v-if="wordData.word2!=''">原著かな：{{wordData.word2}}</div>
                            <div v-if="wordData.phoneme2!=''">原著音韻：{{wordData.phoneme2}}</div>
                        </li>
                    </ul>
    
                    <div class="detail-jp">
                        <span v-for="(jplang, index) in wordData.jplang" :key="index">
                                                        <span v-show="index!=0">、</span>{{jplang.word_kanji}}
                        </span>
                    </div>
    
                    <div class="card-body">
                        <div class="details">
    
    
                            <div class="details-example" v-for="(meaning , index) in wordData.meaning" :key="index">
                                <div class="detail-part" v-show="dispMean(meaning,index)">
                                    <ul>
                                        <li>{{meaning.partname}}&nbsp;{{meaning.subpartname}}&nbsp;{{wordData.inflectionname}}&nbsp;{{wordData.subinflectionname}}</li>
                                        <li class="-last">原著&nbsp;{{meaning.dpartname}}&nbsp;{{wordData.dinflectionname}}</li>
                                    </ul>
                                </div>
    
                                <div class="text">
                                    {{meaning.meaning}}
                                </div>
                                <div class="block-details">
                                    <div class="block-details-box">
                                        <table class="table table-details-example">
                                            <tr v-for="(example, index) in meaning.example" :key="index">
                                                <td class="voice-icon-wrap">
                                                    <div class="voice-icon">
                                                        <ul>
                                                            <li class="icon1" v-show="example.vfname_m_url!==''">
                                                                <a href="#" @click="soundPlay(example.vfname_m_url)">
                                                                    <img :src="ojiImage" />
                                                                </a>
                                                            </li>
                                                            <li class="icon2" v-show="example.vfname_f_url!==''">
                                                                <a href="#" @click="soundPlay(example.vfname_f_url)">
                                                                    <img :src="obaImage" />
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="text-area">
                                                        {{example.diarect}}
                                                        <p class="font2">
                                                            {{example.phoneme}}
                                                        </p>
                                                        <p class="text">
                                                            {{example.common}}
                                                        </p>
                                                    </div>
                                                </td>
                                            </tr>
    
                                        </table>
                                    </div>
                                </div>
                            </div>
    
    
                            <div class="details-reference">
                                <div class="tit2">参考</div>
                                <div class="text">
                                    {{wordData.reference}}
                                </div>
                            </div>
                            <div class="clearfix">
                                <div class="details-image">
     
                                    <img :src="getImagePath(wordData.dicid,wordData.ovid,wordData.ifname)" alt="写真">
                                </div>
                            </div>
                        </div>
                    </div>
    
    
    
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .showcomp {
        z-index: 1;
        display: block;
    }

     .times-new-roman{
        font-family: 'Times New Roman';
    }
</style>

<script>
    import {
        CONTENTS_SRV
    } from "@/services/config";

    export default {
        name: "CompWord",
        props: {
            msg: String
        },
        computed: {
            isCompView() {
                return this.$store.getters.isCompView;
            },
            wordData() {
                return this.$store.getters.compData;
            }
        },
        data() {
            return {
                /* おじーのアイコン */
                ojiImage: require("../assets/img/illust-oji-close.png"),
                ojiImageoff: require("../assets/img/illust-oji-off.png"),
                ojiImageClose: require("../assets/img/illust-oji-close.png"),
                ojiImagePlay: require("../assets/img/illust-oji-play.gif"),
    
                /* おばーのアイコン */
                obaImage: require("../assets/img/illust-oba-close.png"),
                obaImageClose: require("../assets/img/illust-oba-close.png"),
                obaImageoff: require("../assets/img/illust-oba-off.png"),
                obaImagePlay: require("../assets/img/illust-oba-play.gif"),

                oldPart: ''
            }
        },
        methods: {
            dispMean(meaning, index) {
                if (index == 0)
                    return true
    
                var newPart = `${meaning.vid}/${meaning.partname}/${meaning.subpartname}`
                var ret = true
                if (newPart == self.oldPart) {
                    ret = false
                }
                self.oldPart = newPart
                return ret
            },
            getImagePath(dicid, ovid,filename){

                if(filename === undefined || ovid === undefined){
                    return require("../assets/img/no-image.jpg");
                }
                return filename ===''? require("../assets/img/no-image.jpg") : `${CONTENTS_SRV}/dicimage/${dicid}/${ovid.substr(3,4)}/${filename}`;
            },
            closeComp() {
                this.$store.dispatch('upIsCompView', false);
            },
            soundPlay(sound) {
                var audio = new Audio(sound);
                audio.play();
            },
    
        }
    };
</script>